.mbsc-timeline-parent {
  height: 50px !important;
}

.mbsc-timeline-row {
  height: 85px !important;
  padding: 0 !important;
}

.mbsc-timeline-parent {
  height: 50px !important;
}

.mbsc-calendar {
  border-radius: 16px;
}

/* .mbsc-calendar .mbsc-ios {
  background-color: rgba(249, 249, 253, 1) !important;
}

.mbsc-calendar .mbsc-ios-dark {
  background-color: rgba(18, 18, 22, 1) !important;
} */

.mbsc-calendar-header {
  padding: 16px !important;
}

.mbsc-ios .mbsc-calendar-title {
  color: rgba(0, 0, 0, 1);
}

.mbsc-ios-dark .mbsc-calendar-title {
  color: rgba(255, 255, 255, 1);
}

.mds-header-filter-prev,
.mds-header-filter-today,
.mds-header-filter-next {
  color: rgba(0, 0, 0, 1) !important;
}

.mds-header-filter-prev-dark,
.mds-header-filter-today-dark,
.mds-header-filter-next-dark {
  color: rgba(255, 255, 255, 1) !important;
}
